import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import PropTypes from 'prop-types';

import './VettingPersonalDetails.css';

import VettingDropDown from '../../Common/VettingDropDown/VettingDropDown';

import VettingInput from '../../Common/VettingInput/VettingInput';

import KeyValueDataComponent from '../../CreditVetting/KeyValueDataComponent/KeyValueDataComponent';

import {
  SalesContext
} from './../../../Context/SalesContext';

import {
  FormFieldLabel
} from '../../../StyledComponents';

import {
  checkInputValidity,
  getKeyValueData,
  createArray,
  registerEnterEvent,
  validateDate,
  validateDateOfBirth
} from '../../../Utility/utility';

const VettingPersonalDetails = (props) => {
  const context = useContext(SalesContext);
  const personalDetailsData = context.vettingCreditDetails.personalDetails;
  const dropDownValues = context.dropDownValues;
  const maritalStatusArray = dropDownValues?.MARITAL_STATUSES;

  const SAIDNumber = context.employmentDetails.selectedIdTab === 'idNumber' ? context.employmentDetails.idNumber : null;
  let dobFromID, genderFromID;

  if (SAIDNumber){
    dobFromID = [
      SAIDNumber?.slice(0, 2) < 30 ? `20${ SAIDNumber?.slice(0, 2) }` : `19${ SAIDNumber?.slice(0, 2) }`,
      SAIDNumber?.slice(2, 4),
      SAIDNumber?.slice(4, 6)
    ];
    genderFromID = SAIDNumber?.slice(6, 10) <= 4999 ? 'Female' : 'Male';
  }else{
    dobFromID = null;
    genderFromID = null;
  }

  const [ formData, setFormData ] = useState({
    // Form Fields
    formComponents: {
      title: {
        name: 'Title',
        type: 'dropDown',
        value: personalDetailsData?.title?.value || '',
        options: genderFromID ? genderFromID.toLocaleLowerCase() === 'male' ? [ 'Mr.', 'Prof.', 'Dr.' ] : [ 'Mrs.', 'Miss.', 'Prof.', 'Dr.' ] : [ 'Mr.', 'Mrs.', 'Miss.', 'Prof.', 'Dr.' ],
        width: 100,
        validations: {
          required: true,
          invalidMessage: 'Please select a title'
        },
        config: {
          type: 'select',
          required: true,
          placeholder: 'Select title',
          tabIndex: '1'
        },
        isValid: false,
        isTouched: false
      },
      firstName: {
        name: 'First name',
        type: 'input',
        value: personalDetailsData?.firstName?.value || '',
        width: 100,
        note: 'As it appears on your ID / passport',
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid name'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Add first name',
          tabIndex: '3'
        },
        isValid: false,
        isTouched: false
      },
      surname: {
        name: 'Surname',
        type: 'input',
        value: personalDetailsData?.surname?.value || '',
        width: 100,
        note: 'As it appears on your ID / passport',
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid surname'
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'Add surname',
          tabIndex: '4'
        },
        isValid: false,
        isTouched: false
      },
      maritalStatus: {
        name: 'Marital status',
        type: 'dropDown',
        value: personalDetailsData?.maritalStatus?.value || '',
        options: maritalStatusArray || [ 'Single', 'Married', 'Divorced', 'Widowed' ],
        width: 50,
        validations: {
          required: true,
          invalidMessage: 'Please select your marital status'
        },
        config: {
          type: 'select',
          required: true,
          placeholder: 'Select status',
          tabIndex: '5'
        },
        isValid: false,
        isTouched: false
      },
      gender: {
        name: 'Gender',
        type: 'dropDown',
        value: personalDetailsData?.gender?.value || genderFromID || genderFromID,
        options: [ 'Male', 'Female' ],
        width: 50,
        extraClass: genderFromID ? 'disableDropDown' : null,
        genderFromID: genderFromID,
        validations: {
          required: true,
          invalidMessage: 'Title selected does not match Gender.'
        },
        config: {
          type: 'select',
          required: true,
          placeholder: 'Select gender',
          tabIndex: '6'
        },
        isValid: SAIDNumber ? !!(genderFromID) : false,
        isTouched: SAIDNumber ? !!(genderFromID) : false
      },
      dobyyyy: {
        name: 'Date of birth',
        type: 'input',
        value: personalDetailsData?.dobyyyy?.value || (dobFromID && dobFromID[0]) || '',
        width: 30,
        validations: {
          required: true,
          type: 'number',
          invalidMessage: 'Please enter a valid date of birth',
          minLength: 4,
          maxLength: 4
        },
        config: {
          type: 'text',
          required: true,
          placeholder: 'year',
          tabIndex: '8',
          disabled: genderFromID ? 'disabled={disabled}' : null
        },
        isValid: SAIDNumber ? !!(dobFromID) : false,
        isTouched: SAIDNumber ? !!(dobFromID) : false
      },
      dobmm: {
        name: 'Month',
        hideLabel: true,
        type: 'dropDown',
        value: personalDetailsData?.dobmm?.value || (dobFromID && dobFromID[1]) || '',
        options: [ '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12' ],
        width: 30,
        extraClass: genderFromID ? 'disableDropDown' : null,
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid date of birth'
        },
        config: {
          type: 'select',
          required: true,
          placeholder: 'month',
          tabIndex: '9'
        },
        isValid: SAIDNumber ? !!(dobFromID) : false,
        isTouched: SAIDNumber ? !!(dobFromID) : false
      },
      dobdd: {
        name: 'Date',
        hideLabel: true,
        type: 'dropDown',
        value: personalDetailsData?.dobdd?.value || (dobFromID && dobFromID[2]) || '',
        options: [ '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31' ],
        width: 30,
        extraClass: genderFromID ? 'disableDropDown' : null,
        validations: {
          required: true,
          invalidMessage: 'Please enter a valid date of birth'
        },
        config: {
          type: 'select',
          required: true,
          placeholder: 'day',
          tabIndex: '10'
        },
        isValid: SAIDNumber ? !!(dobFromID) : false,
        isTouched: SAIDNumber ? !!(dobFromID) : false
      }
    },
    isFormValid: false,
    formSubmitAttempt: 0,
    hasError: false
  });

  // Create array
  const formCompArray = createArray(formData.formComponents);

  registerEnterEvent();

  useEffect(() => {
    // if (props.isEditModeOn) {
    const formCompsCopy = { ...formData.formComponents };
    for (let key in personalDetailsData) {
      if (personalDetailsData[key] === '') {
        continue;
      }

      const changedComponent = { ...formCompsCopy[key] };
      if (Object.keys(changedComponent).length !== 0) {
        changedComponent.value = personalDetailsData[key].value;

        changedComponent.isValid = checkInputValidity(
          changedComponent.value,
          changedComponent.validations
        );

        changedComponent.isTouched = true;

        formCompsCopy[key] = changedComponent;
      }
    }

    const isFormValid = !Object.keys(formCompsCopy).find(e => formCompsCopy[e].isValid === false) ? true : false;
    setFormData({
      formComponents: formCompsCopy,
      isFormValid: isFormValid
    });

    if (isFormValid) {
      props.toggleNext(true);
    } else {
      props.toggleNext(false);
    }
    // }
  }, [ props.isEditModeOn ]);

  useEffect(() => {
    const formCompsCopy = { ...formData.formComponents };
    formCompsCopy['maritalStatus'].options = maritalStatusArray;
    setFormData({
      formComponents: formCompsCopy
    });
  }, [ dropDownValues ]);

  const formComponentChangeHandler = (event, inputIdentifier) => {
    const formCompsCopy = { ...formData.formComponents };
    let changedComponent = { ...formCompsCopy[inputIdentifier] };
    changedComponent.value = event;
    if (changedComponent.validations.type === 'number') {
      let lastChar = changedComponent.value.slice(-1);
      if (isNaN(lastChar)) {
        return false;
      }
    }

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    let changedComponentdobyyy;
    if (inputIdentifier === 'dobyyyy' || inputIdentifier === 'dobmm' || inputIdentifier === 'dobdd'){
      let day = inputIdentifier === 'dobdd' ? event : { ...formCompsCopy['dobdd'] }.value;
      let month = inputIdentifier === 'dobmm' ? event :  { ...formCompsCopy['dobmm'] }.value;
      let year = inputIdentifier === 'dobyyyy' ? event : { ...formCompsCopy['dobyyyy'] }.value;
      changedComponentdobyyy = { ...formCompsCopy['dobyyyy'] };
      changedComponentdobyyy.isValid = validateDate(day, month, year);
      if(inputIdentifier === 'dobyyyy'){
        changedComponent.isValid = validateDateOfBirth(day, month, year);
      }
    }

    changedComponent.isTouched = true;
    let changedComponent2;

    if(inputIdentifier === 'title') {
      const genderMapping = {
        'Mr.': 'Male',
        'Mrs.': 'Female',
        'Miss.': 'Female'
      };
      changedComponent2 = { ...formCompsCopy['gender']};
      changedComponent2.value = genderMapping[event] || (SAIDNumber ? changedComponent2.value : '');
      changedComponent2.isValid = true;
    }

    if(inputIdentifier === 'gender'){
      if(event === 'Male'){
        changedComponent.isValid = (
          formCompsCopy['title'].value === 'Mr.' ||
          formCompsCopy['title'].value === 'Dr.' ||
          formCompsCopy['title'].value === 'Prof.'
        ) ? true : false;
      }else if(event === 'Female') {
        changedComponent.isValid = (
          formCompsCopy['title'].value === 'Mrs.' ||
          formCompsCopy['title'].value === 'Miss.'||
          formCompsCopy['title'].value === 'Dr.' ||
          formCompsCopy['title'].value === 'Prof.'
        ) ? true : false;
      }
    }

    let newFormComps;
    if(changedComponent2){
      newFormComps = {
        ...formCompsCopy,
        [inputIdentifier]: changedComponent,
        gender: changedComponent2
      };
    } else if (inputIdentifier === 'dobmm' || inputIdentifier === 'dobdd'){
      newFormComps = {
        ...formCompsCopy,
        [inputIdentifier]: changedComponent,
        dobyyyy: changedComponentdobyyy
      };
    } else{
      newFormComps = {
        ...formCompsCopy,
        [inputIdentifier]: changedComponent
      };
    }

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });

    if (isFormValid) {
      props.toggleNext(true);
    } else {
      props.toggleNext(false);
    }
  };

  const saveDetails = () => {
    const keyValueData = getKeyValueData(formData.formComponents);
    let tempObj = {
      label: 'Date of birth',
      value: `${ keyValueData['dobyyyy'].value }-${ keyValueData['dobmm'].value }-${ keyValueData['dobdd'].value }`
    };
    keyValueData['DOB'] = tempObj;
    context.setVettingDetails('personalDetails', keyValueData);
    props.onNextClick(keyValueData);
  };

  return (
    <React.Fragment>
      <div className="vetting-main-section-wrapper">
        {
          personalDetailsData && !props.isEditModeOn ?
            <KeyValueDataComponent data={personalDetailsData}/>
            :
            <React.Fragment>
              <div className="vetting-pd-wrapper">
                {
                  formCompArray.map(item => {
                    return (
                      <div className={`input-field-wrapper-${ item?.config?.width }`} key={item.key}>
                        <FormFieldLabel
                          hide={item?.config?.hideLabel ? 1 : 0}
                          automationidattr={`personalDetails${ item.config?.name }`}
                        >
                          {item.config.name}
                        </FormFieldLabel>
                        {
                          item.config.type === 'input' ?
                            <VettingInput
                              {...item.config}
                              updateValue={formComponentChangeHandler}
                              inputIdentifier={item.key}
                              automationidattr={'personalDetails'}

                            />
                            :
                            null
                        }
                        {
                          item.config.type === 'dropDown' ?
                            <VettingDropDown
                              {...item.config}
                              selectedValue={item.config?.value}
                              placeholder={item.config?.config?.placeholder}
                              options={item.config?.options}
                              updateSelectedOption={formComponentChangeHandler}
                              inputIdentifier={item?.key}
                              automationidattr={'personalDetails'}
                            />
                            :
                            null
                        }
                      </div>
                    );
                  })
                }
              </div>
              {
                props.showBody ?
                  <div className="vetting-next-wrapper">
                    <button
                      className={`vetting-section-next-button ${ props.enableNext ? 'next-enabled' : '' }`}
                      onClick={() => saveDetails()}
                      disabled={props.enableNext  ? '' : 'disabled'}
                    >
                      Next
                    </button>
                  </div>
                  :
                  null
              }
            </React.Fragment>
        }
      </div>

    </React.Fragment>
  );
};

VettingPersonalDetails.propTypes = {
  enableNext: PropTypes.bool,
  isEditModeOn: PropTypes.bool,
  onNextClick: PropTypes.func,
  showBody: PropTypes.bool,
  toggleNext: PropTypes.func
};

export default VettingPersonalDetails;